import { RedoOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Layout, Row, Space } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { Alert } from "components/elements";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useWorkFlow from "../hooks/useWorkFlow";
import { getWorkFlowTypeByGroup } from "../services/leaveTypeApi";
import { setIsLoading as setIsLoading2 } from "../slices/holidaySlice";
import { setWorkFlowTypeByGroup } from "../slices/workFlowSlice";
import WorkFlowMenu from "./WorkFlowMenu";


const WorkFlowList = ({
    type = null
}) => {
    const { t, i18n } = useTranslation();

    const {
        chainOfCommand = () => { },
        approveByRole = () => { },
        approveByPosition = () => { },
        requester = () => { },
        handleAddComponent = () => { },
        PlusDropdown = () => { },
        reset = () => { },
        onDelete = () => { },
        addNewWorkFlow = () => { },
        RenderNewWorkFlow = () => { },
        RenderCellTwo = () => { },
        stepOfNumber = () => { },
        list = [],
        listworkflow = [],
        setList = () => { },
        RenderCell = () => { },
        HandleSave = () => { },
        onCancel = () => { }
    } = useWorkFlow({ type })

    const dispatch = useDispatch();
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);
    // const isLoading = useSelector((state) => state.workFlow.isLoading);
    const getWorkFlowTypeByGroupFn = useCallback(
        async () => {
            try {
                dispatch(setIsLoading2(true));
                let res = await getWorkFlowTypeByGroup({
                    workFlowGroup: type,
                    companyId: currentCompany
                });
                dispatch(setWorkFlowTypeByGroup(res?.data?.content || []))
                // Alert({ message: "Success" });
            } catch (error) {
                Alert({ type: "error", resultObject: error });
                dispatch(setWorkFlowTypeByGroup([]))
            } finally {
                dispatch(setIsLoading2(false));
            }
        },
        [dispatch, type, currentCompany],
    )

    useEffect(() => {
        if (getWorkFlowTypeByGroupFn) {
            getWorkFlowTypeByGroupFn()
            // dispatch(getWorkFlowTypeByGroup())
        }
    }, [getWorkFlowTypeByGroupFn, type])

    // console.log("list?.filter?.(o => o.isEdit)?.length", list?.filter?.(o => o.isEdit)?.length);

    return (
        <Layout style={{
            width: "100%",
        }}>
            <Content style={{
                width: "100%",
                // paddingRight: ""17vw
            }}>
                <Card style={{
                    marginTop: "-20px", borderRadius: "0px 16px 16px 16px", width: "100%"
                }}
                >
                    <WorkFlowMenu />
                    <><Flex style={{ paddingTop: "1vw" }}>
                        <Col span={12}>
                            <Flex style={{ fontSize: "1.5vw" }}>{t('workflow.main_flow')}</Flex>
                        </Col>
                        <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
                            <Flex>
                                <Button style={{
                                    // width: "10vw",
                                    borderRadius: "6rem",
                                    height: "2.5vw",
                                    color: "#9D9D9D"
                                }}
                                    onClick={() => {
                                        reset();
                                    }}><RedoOutlined />{t('workflow.reset-to-default')}</Button>
                            </Flex>
                        </Col>
                    </Flex>
                        <Flex
                            vertical
                            style={{
                                overflowX: "auto",
                                paddingTop: "1vw",
                                paddingBottom: "2vw",
                                width: "100%",
                                flexGrow: 1,
                                minWidth: "100%",
                            }}
                        >
                            <Flex
                                gap={40}
                                style={{
                                    width: "100%",
                                    minWidth: "max-content",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {RenderCell()}
                            </Flex>
                        </Flex>
                        <Flex style={{ fontSize: "1.5vw", overflowX: "auto", paddingTop: "3vw", paddingBottom: "2vw", }}>{t('workflow.custom')}</Flex>
                        <Flex >
                            <Flex vertical style={{
                                overflowX: "scroll", paddingTop: "1vw", paddingBottom: "2vw",
                            }}>
                                <Flex style={{
                                    width: "100%",
                                    minWidth: "max-content",
                                    justifyContent: "flex-start"
                                }} vertical>
                                    {RenderNewWorkFlow(listworkflow)}
                                </Flex>
                                {addNewWorkFlow()}
                            </Flex>
                        </Flex>
                    </>
                </Card>

            </Content>
            <Footer style={{
                display: list?.filter?.(o => o.isEdit)?.length ? "flex" : "none",
                zIndex: 999,
                bottom: 15,
                position: 'sticky',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(90px)',
                borderRadius: '10rem',
                height: "5vh",
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '10px 50px',
                justifyContent: 'end',
                alignItems: 'center',
            }}>
                <Row justify="end" >
                    <Space>
                        <Button
                            type="default"
                            size="large"
                            onClick={() => {
                                onCancel();
                            }}
                        >
                            {t("common.cancel")}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => {
                                HandleSave()
                            }}
                            style={{ backgroundColor: "var(--button-color)" }}
                        >
                            {t("common.submit")}
                        </Button>
                    </Space>
                </Row>
            </Footer>
        </Layout>

    );
};

export default WorkFlowList;
